import { React, Component, Link, Container } from 'utils';
import { App, SelectedPavilionStore, Creators } from 'model';
import './standlinks.less';

class ScrollTo extends Component {

	handleScrollTo = () => {
		var { item } = this.props;
		$(window).trigger('vv.scrollTo', item.slug);
	}
	
	render() {
		var { pavilion, item, selected } = this.props;

		var stand = item.slug;
		var url = App.standUrl(pavilion, stand);

		var css = [ 'stand-link', item.slug ];

		if(selected) {
			css.push('selected');
		}

		return <Link onClick={ this.handleScrollTo } to={ url } className={ css.join(' ') }>
			<span><img className="logo" src={ item.imageUrl }/></span>
		</Link>
	}

}

class StandLinks extends Component {


	constructor(props)
	{
		super(props);
		this.slug = null;
	}

	static getStores() {
		return [SelectedPavilionStore];
	}

	static calculateState() {
		return {
			offset: 0,
			stand: SelectedPavilionStore.getSelectedStandSlug(),
		};
	}

	componentDidMount() {

		this.timer = null;
		this.scrollSpyActive = true;

		$(window).on('vv.repositionStandLinks', this.handleReposition);
		$(window).on('vv.scrollSpy', this.handleScrollSpy)

		this.handleReposition();
	}

	componentWillUnmount() {
		$(window).off('vv.repositionStandLinks', this.handleReposition);
		$(window).on('vv.scrollSpy', this.handleScrollSpy);
	}

	handleScrollSpy = (event, status) => {
		this.scrollSpyActive = status;

		if(this.scrollSpyActive == true) {
			this.slug = null;
		}
	}

	handleWheel = (args) => {
		var box = $(this.links);

		var delta = args.deltaY;
		var left = box.scrollLeft();

		box.scrollLeft(left + delta);
	}

	handleReposition = () => {

		var { stand } = this.state;

		if(this.slug != stand) {
			this.slug = stand;
		} else {
			return;
		}

		var selected = $('.stand-link.selected');

		if(selected.length > 0) {
			var links = $('.stand-links .links');
			var offset = selected.position().left;
			var windowWidth = $(window).width();

			var centerOffset = windowWidth / 2;
			var iconOffset = offset + selected.width() / 2 - centerOffset;

			$('.stand-links').clearQueue().animate({ scrollLeft: iconOffset });
		}
	}

	componentDidUpdate() {
		this.handleReposition();
	}

	render()
	{
		var { data } = this.props;
		var { offset, stand } = this.state;

		if (data) {
			var {stands} = data;
			var pavilion = data.slug;

			var links = stands.map((item, index) => {
				var selected = (stand == 'first' && index == 0) || item.slug == stand;
				return <ScrollTo key={ item.id } selected={selected} pavilion={ pavilion } item={ item } />
			});

			return <div className="stand-links" onWheel={ this.handleWheel } ref={(links) => { this.links = links }}>
				<div className="link-box">
					<div className="links">{ links }</div>
				</div>
			</div>
		}
		else {
			return null;
		}
	}
}

export default Container.create(StandLinks);


// WEBPACK FOOTER //
// ./src/modules/components/standlinks.js